import styled, { css } from "styled-components"
import Hamburger from "../../../components/common/hamburger.component"
import { NavigationSection } from "../../../components/common/sections/section.component"
import { NeutralTextLink } from "../../../ui/components/link/link.component"
import { smallBodyTextStyles } from "../../../components/common/general-styles.component"
import { controlStyle } from "../../../components/common/controls-area/controls-area.component"

export const HeaderWrapper = styled.header<{
  isDark?: boolean
  isMainPage?: boolean
  isOnlyMainPage?: boolean
}>`
  top: 0;
  left: 0;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndexes.headerLayer};
  position: sticky;
  background-color: ${({ theme, isDark }) =>
    isDark ? theme.color.backgroundDark : theme.color.backgroundInverted};
  border-bottom: 1px solid
    ${({ theme, isDark }) =>
      isDark ? theme.color.backgroundDark : theme.color.border};

  ${({ isOnlyMainPage }) =>
    isOnlyMainPage
      ? css`
          margin-bottom: 0;
        `
      : css`
          @media (min-width: ${({ theme }) =>
              theme.breakpoint.tabletHorizontal}px) {
            margin-bottom: 60px;
          }
        `}
`

export const KickstarterHeaderWrapper = styled(HeaderWrapper)`
  position: relative;
  border-bottom: none;
`

export const HeaderSectionWraper = styled.div`
  width: 100%;
  position: relative;
`

export const HeaderSection = styled(NavigationSection)<{
  isMainPage?: boolean
}>`
  z-index: 1;
  display: flex;
  flex-direction: row;
  height: var(--height);
  justify-content: center;
  position: initial;

  ${({ isMainPage }) =>
    isMainPage &&
    css`
      max-width: 1920px !important;
      @media (min-width: 1400px) {
        padding-right: 100px;
      }
    `}

  --height: ${({ theme }) => theme.size.headerHeightMobile}px;
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    --height: ${({ theme }) => theme.size.headerHeightDesktop}px;
  }

  @media (max-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    width: 100%;
  }
`

export const KickstarterHeaderSection = styled(HeaderSection)`
  justify-content: space-between;
  align-items: center;
  width: 100%;
  max-width: 1280px;
  padding-left: 110px;
  padding-right: 200px;
  @media (min-width: ${({ theme }) =>
      theme.breakpoint.tablet}px) and (max-width: ${({ theme }) =>
      theme.breakpoint.desktopMedium}px) {
    padding-left: 50px;
  }
`

export const HeaderContainer = styled.nav<{ isDark?: boolean }>`
  width: 100%;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  justify-content: space-between;
  z-index: 2;
  color: white;
  background-color: ${({ theme, isDark }) =>
    isDark ? theme.color.backgroundDark : theme.color.backgroundInverted};
  @media (max-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    padding: 0 30px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoint.tablet}px) {
    padding: 0 15px;
  }

  @media (max-width: 350px) {
    padding: 0 5px;
  }
`

export const Logo = styled.img`
  height: 36%;
  width: auto;
  display: block;
  @media (max-width: ${({ theme }) =>
      theme.breakpoint.mobileHorizontal - 1}px) {
    max-width: 100px;
  }
`

export const LogoLink = styled(NeutralTextLink)`
  flex: 2;
  height: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  margin-right: 30px;
`

export const mobileOnly = css`
  @media (min-width: ${({ theme }) => theme.breakpoint.tabletHorizontal}px) {
    display: none;
  }
`

export const HamburgerControl = styled(Hamburger)`
  padding: 0;
  ${smallBodyTextStyles};
  ${controlStyle};
  ${mobileOnly};
`
